<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <ifc-account-loan-number-input [fc]="form.get('loanNumber')" baseFilterItem></ifc-account-loan-number-input>
    <ifc-account-application-number-input
      [fc]="form.get('applicationNumber')"
      baseFilterItem
    ></ifc-account-application-number-input>

    <ifb-business-name-input
      [disabled]="!data.canFilterByEntity"
      [fc]="form.get('businessName')"
      baseFilterItem
    ></ifb-business-name-input>
    <ifc-filter-param-date-range-input
      [fc]="form.get('createdOn')"
      [label]="'Created on'"
      (rangeSelected)="createdDateSelected($event)"
      baseFilterItem
    />

    <ng-container *ngIf="form.get('createdOn').value === 'custom'">
      <ifc-datepicker [fc]="form.get('createdOnFrom')" [label]="'Created on from'" baseFilterItem></ifc-datepicker>
      <ifc-datepicker [fc]="form.get('createdOnTo')" [label]="'Created on to'" baseFilterItem></ifc-datepicker>
    </ng-container>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Loan Status</mat-label>
      <mat-select formControlName="status" multiple placeholder="Loan Status">
        <mat-option *ngFor="let option of statusOptions" [value]="option.value">
          {{ option.name | startCase }}
        </mat-option>
      </mat-select>
      <button
        type="button"
        *ngIf="form.get('status').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('status').setValue(null)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Delinquent Status</mat-label>
      <mat-select multiple formControlName="delinquentStatus" placeholder="Delinquent Status">
        <mat-option *ngFor="let option of delinquentStatusOptions" [value]="option.value">
          {{ option.name | startCase }}
        </mat-option>
      </mat-select>
      <button
        type="button"
        *ngIf="form.get('delinquentStatus').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('delinquentStatus').setValue(null)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <ifc-filter-param-date-range-input
      [fc]="form.get('renewalOn')"
      [label]="'Renewal date'"
      (rangeSelected)="renewalDateSelected($event)"
      baseFilterItem
    />
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>{{ canReadFacilities ? 'Facility' : 'No facilities permission' }}</mat-label>
      <mat-select formControlName="facilityId" placeholder="All" [disabled]="!canReadFacilities">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let facility of facilities" [value]="facility.id">{{ facility.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container *ngIf="form.get('renewalOn').value === 'custom'">
      <ifc-datepicker [fc]="form.get('renewalOnFrom')" [label]="'Renewal on from'" baseFilterItem></ifc-datepicker>
      <ifc-datepicker [fc]="form.get('renewalOnTo')" [label]="'Renewal on to'" baseFilterItem></ifc-datepicker>
    </ng-container>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Activation stage</mat-label>
      <mat-select formControlName="activationStage" placeholder="All">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let option of activationStageOptions" [value]="option.value">{{ option.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select matInput formControlName="active" placeholder="Status">
        <mat-option>All</mat-option>
        <mat-option value="true">Active</mat-option>
        <mat-option value="false">Inactive</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Product type</mat-label>
      <mat-select formControlName="productCode" placeholder="All">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let option of productTypeOptions" [value]="option.value">{{ option.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <ifc-account-case-name-input [fc]="form.get('description')" baseFilterItem></ifc-account-case-name-input>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Brand</mat-label>
      <mat-select formControlName="companyId" placeholder="All">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let company of companies" [value]="company.id">{{ company.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Loan modification</mat-label>
      <mat-select matInput multiple formControlName="modificationFlags" placeholder="Loan modification">
        <mat-option *ngFor="let option of modificationFlagOptions" [value]="option.value">{{ option.name }}</mat-option>
      </mat-select>
      <button
        type="button"
        *ngIf="form.get('modificationFlags').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('modificationFlags').setValue(null)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Balance from</mat-label>
      <input matInput type="text" currencyMask formControlName="minBalance" />
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Balance to</mat-label>
      <input matInput type="text" currencyMask formControlName="maxBalance" />
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Payment amount from</mat-label>
      <input matInput type="text" currencyMask formControlName="minPaymentAmount" />
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Payment amount to</mat-label>
      <input matInput type="text" currencyMask formControlName="maxPaymentAmount" />
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Payment frequency</mat-label>
      <mat-select formControlName="paymentFrequency" placeholder="All">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let option of paymentFrequencyOptions" [value]="option.value">{{ option.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <ifc-filter-param-date-range-input
      [fc]="form.get('upcomingPaymentDateOn')"
      [label]="'Upcoming payment on'"
      (rangeSelected)="upcomingPaymentDateSelected($event)"
      baseFilterItem
    />

    <ng-container *ngIf="form.get('upcomingPaymentDateOn').value === 'custom'">
      <ifc-datepicker
        [fc]="form.get('minUpcomingPaymentDate')"
        [label]="'Upcoming payment on from'"
        baseFilterItem
      ></ifc-datepicker>
      <ifc-datepicker
        [fc]="form.get('maxUpcomingPaymentDate')"
        [label]="'Upcoming payment on to'"
        baseFilterItem
      ></ifc-datepicker>
    </ng-container>
  </ifc-base-filter-dialog>
</form>
